export function Host (data = {}) {
  this.name = data.username || null
  this.id = data.id || null
  this.stripeAccount = data['stripe_account'] || null

  // Some day we may want a more refined role-based auth rather than just a host/admin split.
  // This would allow for demo accounts that don't actually publish events or hosts with
  // different levels of permissions, for example
  this.isAdmin = data.admin || false
}
